var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu-dropdown-item-icon",on:{"mouseenter":function($event){_vm.show = true},"mouseleave":function($event){_vm.show = false}}},[_c('k-link',{attrs:{"to":_vm.to,"link":_vm.link}},[_c('font-awesome-icon',{attrs:{"to":{},"icon":_vm.icon},on:{"click":_vm.onClick}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }